import { Injectable } from '@angular/core';
import { SubSystem } from "../models/subsystem.enum";
import { SystemStatusService } from './systemstatus.service';
import { HttpClient } from '@angular/common/http';
import { Subscriber, throwError, Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpService } from './http.service';
import { HttpRequestOptions, HttpResponse, HttpStatus, HttpContentType } from '../models/http';
import { EventBusService, EventType, ATMEventData } from './eventbus.service';
import {AngularClientService} from './angularclient.service';
import { User } from '@csx/security';

@Injectable()
export class HttpClientService extends HttpService {
    constructor(eventBus: EventBusService, private http:AngularClientService, private user: User) {
        super(eventBus);
    }

    public request(options: HttpRequestOptions, forceFetch?: boolean): Observable<HttpResponse> {
        let serviceResponse: HttpResponse;
        let serviceError: HttpResponse;

        if (window.navigator.onLine || forceFetch) {
            return new Observable<HttpResponse>(observer => {
                let response = this.http.invoke(options).subscribe(
                     response => {
                        this.eventBus.fireEvent(EventType.ONLINE_EVENT, new ATMEventData(null, () => ''));
                        if (response.status === 200 || response.status === 204) {
                            serviceResponse = new HttpResponse(HttpStatus.Success, response.status, response.body);
                            this.handleNotifications(options, serviceResponse);
                            observer.next(serviceResponse);
                        } else {
                            console.error("Service Failure", response);
                            let errorMessage: string;
                            let errors: any = [];
                            serviceError = new HttpResponse(HttpStatus.Error, response.status, errors, errorMessage);
                            this.handleNotifications(options, serviceError)
                            observer.error(serviceError);
                        }

                        observer.complete();
                    },
                     error => {
                        console.error("HTTP failure", error);
                        const errorObj = error.error;
                        if (errorObj && errorObj.message) {
                            serviceError = new HttpResponse(HttpStatus.Error, error.status, [], errorObj.message);
                        }

                        else if (errorObj &&  !errorObj.message) {
                            serviceError = new HttpResponse(HttpStatus.Error, error.status, [], error.statusText);
                        }

                        else if (error.status === 0 && errorObj &&  !errorObj.message) {
                            this.eventBus.fireEvent(EventType.OFFLINE_EVENT, new ATMEventData(null, () => ''));
                        }
                        else {
                            serviceError = new HttpResponse(HttpStatus.Error, -1, undefined, "The system is currently unreachable");
                        }

                        this.handleNotifications(options, serviceError);

                        if (error.errorCode !== undefined && error.errorCode === 'REQUEST_TIMEOUT') {
                            // CSXMobile.online = true;
                        }
                        observer.error(serviceError);
                    },
                    // timeout: options.timeout === undefined ? 30000 : options.timeout
                );
            });
        }

        serviceError = new HttpResponse(HttpStatus.Offline, -1, undefined, "The system is offline");
        this.eventBus.fireEvent(EventType.OFFLINE_EVENT, new ATMEventData(null, () => ''));

        this.handleNotifications(options, serviceError);

        return throwError(serviceError);
    }
}